<script>
	import './index.scss';

	import { pkgBrief } from "../store.js";

	let currentDate = new Date();
	let currentDateString = currentDate.getFullYear() + (currentDate.getMonth()+1) + currentDate.getDate();

	function orderTemplate() {
		$pkgBrief = [
		{
			type: 0,
			content: "Order ",
			detail: ""
		},
		{
			type: 0,
			content: "Deadline:",
			detail: ""
		},
		{
			type: 3,
			content: currentDateString,
			detail: ""
		},
		{
			type: 0,
			content: "Briefing:",
			detail: ""
		},
		{
			type: 1,
			content: "",
			detail: ""
		}
		];
	};

	function revisionTemplate() {
		$pkgBrief = [
		{
			type: 0,
			content: "Revision ",
			detail: ""
		},
		{
			type: 1,
			content: "",
			detail: ""
		}
		];
	};

	function resetTemplate() {
		$pkgBrief = [];
	};
</script>

<div class="container box has-background-grey-dark has-text-white is-hidden-touch">
	<div class="columns ">
		<div class="column">
			<button class="button is-warning is-fullwidth is-outlined" on:click={() => orderTemplate()}>Order Template</button>
		</div>
		<div class="column">
			<button class="button is-warning is-fullwidth is-outlined" on:click={() => revisionTemplate()}>Revision Template</button>
		</div>
		<div class="column">
			<button class="button is-danger is-fullwidth is-outlined" on:click={() => resetTemplate()}>Reset Brief</button>
		</div>
	</div>
</div>

<div class="container box has-background-grey-dark has-text-white is-hidden-desktop">
	<div class="columns">
		<div class="column">
			<div class="dropdown">
				<div class="dropdown-trigger">
					<button class="button is-outlined is-warning" aria-haspopup="true" aria-controls="dropdown-menu">
						<span>Brief Template</span>
						<span class="icon is-small">
							<i class="fas fa-angle-down" aria-hidden="true"></i>
						</span>
					</button>
				</div>
				<div class="dropdown-menu" id="dropdown-menu" role="menu">
					<div class="dropdown-content has-background-dark">
						<a class="dropdown-item has-text-warning" on:click={() => orderTemplate()}>
							Order Template
						</a>
						<a class="dropdown-item has-text-warning" on:click={() => revisionTemplate()}>
							Revision Tenmplate
						</a>
						<a class="dropdown-item has-text-danger" on:click={() => resetTemplate()}>
							Reset Brief
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>